module.exports = __webpack_public_path__ + "static/media/cell@2x.3005d0b9.png";